export default __webpack_public_path__ + "static/media/bg6.0273c8d2.jpg";